import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Speakeasy is speech generating software designed for a child with cerebral palsy.`}</p>
    <p>{`The application is built using the MEAN stack (MongoDB, Express.js, AngularJS and Node.js). It uses AngularJS for the dynamic functionality. Speech is handled using Google's Speech Synthesis library. The key feature is semantic compaction, which combines chosen words to form more complex sentences. This can increase the rate at which speech can be produced.`}</p>
    <p>{`There is an advertisement video below that was created to demonstrate and explain the software.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      